import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { RadarProps } from "./Radar.types";
import ProfileCircle from "../../molecules/ProfileCircle/ProfileCircle";

import { Skill, SkillCategory } from "../../types/scores.types";

import "./Radar.scss";

import Pie from "./ui/Pie";

const Radar: React.FC<RadarProps> = ({
  skills,
  selectedCategory,
  handleCategorySelected,
  sort,
  combineCategories,
  disabledIndices = [],
  profileCirclePercent = 0.3,
  diameter = 400,
}) => {
  const [hoverSkill, setHoverSkill] = useState<Skill | null>();

  const pad = diameter / 40;
  const radius = diameter / 2;

  const pieRadius = radius - pad * 5;

  const profileRadius = profileCirclePercent * pieRadius;

  const [skillset, setSkillset] = useState(skills);

  useEffect(() => {
    if (selectedCategory || !combineCategories) {
      setSkillset(skills);
    } else {
      const newSkills: Array<Skill> = [
        {
          id: 10,
          label: "Complex Reasoning",
          category: SkillCategory.complexReasoning,
          overall: {
            percentile: 1.0,
            zScore: 0,
          },
        },
        {
          id: 11,
          label: "Memory",
          category: SkillCategory.memory,
          overall: {
            percentile: 0.5,
            zScore: 0,
          },
        },
        {
          id: 12,
          label: "Exectuive Functions",
          category: SkillCategory.executiveFunctions,
          overall: {
            percentile: 0.35,
            zScore: 0,
          },
        },
      ];
      setSkillset(newSkills);
    }
  }, [skills, selectedCategory, combineCategories, disabledIndices]);

  return (
    <>
      <motion.div
        data-testid="Radar"
        className="mp-charts-radar--main"
        style={{ width: diameter, height: diameter }}
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{
          opacity: 1.0,
          scale: 1.0,
        }}
        transition={{
          scale: { type: "spring" },
        }}
      >
        <div
          className="profile-container"
          style={{
            width: diameter,
            height: diameter,
          }}
        >
          <motion.div
            className="profile-container-absolute"
            style={{
              width: profileRadius * 2,
              height: profileRadius * 2,
            }}
          >
            <ProfileCircle
              imageSource="https://mindprint-general.s3.amazonaws.com/profiles/default/avatar-06.png"
              backgroundColor={"#ffcb05"}
              size={profileRadius * 2}
              onClick={() => {
                handleCategorySelected(undefined);
              }}
            />
          </motion.div>
          {skillset && (
            <Pie
              skills={skillset}
              diameter={diameter}
              selectedCategory={selectedCategory}
              sort={sort}
              pad={pad}
              profileCirclePercent={profileCirclePercent}
              pieRadius={pieRadius}
              handleCategorySelected={handleCategorySelected}
              onHover={(skill: Skill) => {
                setHoverSkill(skill);
              }}
              disabledIndices={disabledIndices}
            />
          )}
        </div>
        {/* <div className="info">{hoverSkill && <>{hoverSkill.label}</>}</div> */}
      </motion.div>
    </>
  );
};

export default Radar;
